/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Field_Category_PlaceholderInputs */

const en_agent_authorization_field_category_placeholder = /** @type {(inputs: Agent_Authorization_Field_Category_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a category`)
};

const zh_agent_authorization_field_category_placeholder = /** @type {(inputs: Agent_Authorization_Field_Category_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择分类`)
};

/**
* | output |
* | --- |
* | "Choose a category" |
*
* @param {Agent_Authorization_Field_Category_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_field_category_placeholder = /** @type {((inputs?: Agent_Authorization_Field_Category_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Field_Category_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_field_category_placeholder(inputs)
	return zh_agent_authorization_field_category_placeholder(inputs)
});
export { agent_authorization_field_category_placeholder as "agent.authorization.field.category_placeholder" }